import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { App } from '@/App'
import '@/lang/i18n'
import '@/styles/global.scss'
import { reportFunnelAssignment } from '@/utils/analytics'
import { maskSplitMarks } from '@/utils/maskParams'
import { captureThankYouReturn } from '@/utils/thankYouParams'

/* ДО РЕНДЕРА, и в этом порядке (2026-09-28). Сначала адрес возврата с оплаты: почта и user_id
   покупателя забираются из /thank-you и адрес очищается раньше, чем App.tsx отправит первый PageView
   в пиксель и GA (utils/thankYouParams.ts). Потом назначение воронки: `funnel_assigned` должен уйти
   первым событием загрузки — дочерние эффекты вроде `onboarding_started` срабатывают раньше
   `page_viewed` из App, и только отсюда событие гарантированно их опережает. */
captureThankYouReturn()
/* Метки сплита `?r=` и `?v=` серверу уже не нужны — cookie лежат в ответе с этим HTML; в адресной
   строке они только выдавали бы тест (utils/maskParams.ts). Раньше первого PageView, чтобы и площадки
   их не видели. */
maskSplitMarks()
reportFunnelAssignment()

const container = document.getElementById('root')
if (!container) throw new Error('#root is missing from index.html')

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
